<div class="container margin">
    <div style="margin: 20px;">
        <h1> Intercambiar Información:</h1>
        <form [formGroup]="form" (ngSubmit)="handlerData(form.value)">
            <div style='display: flex; width: 100%; '>
                <div style='flex:10'>

                                <div class='first-row'>

                                  <mat-form-field>
                                    <mat-label>Compañia obtener informacion</mat-label>
                                    <mat-select formControlName='companyFrom'>
                                        <mat-option *ngFor='let c of companies' value='{{c.id}}'>
                                            {{c.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field>
                                  <mat-label>Compañia enviar informacion</mat-label>
                                  <mat-select formControlName='companyTo'>
                                      <mat-option *ngFor='let c of companies' value='{{c.id}}'>
                                          {{c.nombre}}
                                      </mat-option>
                                  </mat-select>
                              </mat-form-field>


                              <mat-form-field>
                                <mat-label>Tabla a enviar</mat-label>
                                <mat-select formControlName='typeDataId'>
                                    <mat-option *ngFor='let t of typeData' value='{{t.id}}'>
                                        {{t.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                                </div>
                </div>



                <div style='flex:.2'>

                    <button mat-mini-fab color="warn" type="submit">
                        <mat-icon>save</mat-icon>
                    </button>

                </div>

            </div>
        </form>
    </div>

    <div *ngIf="copyQuestions">
      <form [formGroup]="formQuestions" (ngSubmit)="createQuestion(formQuestions.value)">
        <div style='display: flex; width: 100%; '>
            <div style='flex:10'>

                            <div class='first-row'>

                              <mat-form-field>
                                <mat-label>Tipo Equipo Compañia obtener informacion</mat-label>
                                <mat-select formControlName='typeEquipmentFrom'>
                                    <mat-option *ngFor='let c of typeEquipmentFrom' value='{{c.id}}'>
                                        {{c.nombre}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field>
                              <mat-label>Tipo Equipo Compañia enviar informacion</mat-label>
                              <mat-select formControlName='typeEquipmentTo'>
                                  <mat-option *ngFor='let c of typeEquipmentTo' value='{{c.id}}'>
                                      {{c.nombre}}
                                  </mat-option>
                              </mat-select>
                          </mat-form-field>

                          </div>
            </div>



            <div style='flex:.2'>

                <button mat-mini-fab color="warn" type="submit">
                    <mat-icon>save</mat-icon>
                </button>

            </div>

        </div>
    </form>
    </div>


</div>
